import { useSyncExternalStore } from 'react';
import { apercuActif, definirApercu } from '../../../services/apercu';

/**
 * État de l'aperçu de rôle, partagé entre le client API et les écrans.
 *
 * Le client API a besoin d'une valeur lisible SYNCHRONEMENT au moment de
 * construire la requête — donc hors de React. Mais l'interface doit se
 * redessiner quand elle change. D'où ce petit magasin : une source unique, et
 * `useSyncExternalStore` pour que React la surveille.
 *
 * La première version faisait vivre l'aperçu dans une simple variable de
 * module : le client l'envoyait bien, mais aucun composant ne se redessinait.
 * L'écran donnait donc l'impression que le clic n'avait rien fait.
 */
const abonnes = new Set<() => void>();

function abonner(rappel: () => void) {
  abonnes.add(rappel);
  return () => abonnes.delete(rappel);
}

export function changerApercu(id: string | null) {
  definirApercu(id);
  for (const rappel of abonnes) rappel();
}

export function useApercu(): string | null {
  return useSyncExternalStore(abonner, apercuActif, () => null);
}
